module.exports = __webpack_public_path__ + "static/media/4D.72d20001.svg";